module.exports = __webpack_public_path__ + "static/media/logo_card01.f31f4f5d.png";